module.exports = __webpack_public_path__ + "static/media/CTLI_16-391w.ae42af79.webp";